module.exports = __webpack_public_path__ + "static/008283-cfaa00ff04bb5065a6f90e68b113de8d.jpg";